<!-- <div class="container my-5">
  <div class="row">
 
    <div class="col-md-4">
    
      <div class="card shadow-sm mb-4">
        <div class="card-body text-center">
          <h4 class="mb-3">Welcome !</h4>
          <div *ngIf="authenticated; then welcomeUser else signInPrompt"></div>
          <ng-template #welcomeUser>
            <h5 class="text-success">
              Hello {{ user != null ? user.displayName : '' }}!
            </h5>
          </ng-template>
          <ng-template #signInPrompt>
            <button [attr.guide]="'outlook-calender-btn-1' + '__' + sanitizeUrl(url)" class="btn btn-primary btn-sm" (click)="signIn()">Sign in</button>
          </ng-template>
        </div>
      </div>

    </div>
  </div>
</div> -->
<!-- 
<button [attr.guide]="'outlook-calender-btn-2' + '__' + sanitizeUrl(url)" class="btn btn-primary btn-sm" (click)="signIn()">Sign in</button> -->

<button [attr.guide]="'outlook-calender-btn-3' + '__' + sanitizeUrl(url)" *ngIf="!authenticated"
mat-raised-button (click)="signIn()">Sign in Outlook</button>

<button [attr.guide]="'outlook-calender-btn-4' + '__' + sanitizeUrl(url)" *ngIf="authenticated"
mat-raised-button (click)="signOut()">Logout  Outlook</button>
